<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>首充配置</span>
        </div>

        <el-table :data="formData" border stripe>
          <el-table-column prop="start" label="等级范围">
            <template v-slot:default="scope">
              <el-input v-model.number="scope.row.min_level" style="width: 45%" placeholder="最小等级" />
              -
              <el-input v-model.number="scope.row.max_level" style="width: 45%" placeholder="最大等级" />
            </template>
          </el-table-column>
          <el-table-column prop="life_time" label="存在时间">
            <template v-slot:default="scope">
              <el-input v-model.number="scope.row.life_time" placeholder="存在时间" />
            </template>
          </el-table-column>
          <el-table-column prop="price" label="价格">
            <template v-slot:default="scope">
              <el-select v-model="scope.row.price" placeholder="请选择" @change="(v)=>priceChange(v, scope.$index)">
                <el-option
                  v-for="item in shopSku"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </template>
          </el-table-column>
          <el-table-column prop="discount" label="折扣">
            <template v-slot:default="scope">
              <el-input v-model.number="scope.row.discount" placeholder="折扣" />
            </template>
          </el-table-column>
          <el-table-column prop="status" label="状态">
            <template v-slot:default="scope">
              <el-select v-model="scope.row.status" placeholder="请选择">
                <el-option
                  v-for="item in statusType"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </template>
          </el-table-column>
          <el-table-column prop="skin_dir" label="配图文件路径">
            <template v-slot:default="scope">
              <el-input v-model.number="scope.row.skin_dir" />
            </template>
          </el-table-column>
          <el-table-column prop="skin_dir" label="奖励">
            <template v-slot:default="scope">
              {{ getRewardList(scope.row.prize_json) }}
            </template>
          </el-table-column>
          <el-table-column label="奖励配置">
            <template v-slot:default="scope">
              <el-button type="primary" style="margin-left: 16px;" @click="drawerArr[scope.$index].visible = true">
                奖励配置
              </el-button>

              <el-drawer
                title="奖励配置"
                :visible.sync="drawerArr[scope.$index].visible"
                direction="rtl"
                size="950px"
                :before-close="(d)=>handleClose(d, scope.$index)"
              >
                <commonReward v-model="scope.row.prize_json" />
              </el-drawer>
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template v-slot:default="scope">
              <el-button v-permisaction="['config:firstPurchas:del']" type="danger" @click="del(scope.row.id)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-button v-permisaction="['config:firstPurchas:add']" type="primary" style="margin-top: 10px" @click="add()">+</el-button>
        <el-button v-permisaction="['config:firstPurchas:add']" type="primary" style="margin-top: 10px" @click="onSubmit()">保存</el-button>
        <pagination
          v-show="total>0"
          background
          :page.sync="queryParams.pageIndex"
          :limit.sync="queryParams.pageSize"
          :total="total"
          @pagination="getTables"
        />
      </el-card>

    </template>
  </BasicLayout>
</template>

<script>
import { deleteShopCfg, getShopCfgList, getSku, updateShopCfg } from '@/api/config/shop-cfg'
import { getRewardType } from '@/api/config/slot'
import { getRewardListForPropsId } from '@/utils'
import commonReward from '@/components/Reward/index.vue'

export default {
  name: 'FirstPurchase',
  components: {
    commonReward
  },
  data() {
    return {
      drawerArr: [{ visible: false }],
      shopSku: [],
      rewardType: [],
      statusType: [{ label: '上架', value: 1 }, { label: '下架', value: 0 }],
      total: 0,
      queryParams: {
        pageIndex: 1,
        pageSize: 10,
        type: this.gType
      },
      gType: 109,
      selectType: [
        {
          'id': 1,
          'title': '只取数量'
        },
        {
          'id': 2,
          'title': '等级取值'
        }
      ],
      formData: [
        {
          'id': 0,
          'gid': 601,
          'g_type': this.gType,
          'min_level': 0,
          'max_level': 0,
          'life_time': 0,
          'price': 0,
          'sku': '',
          'discount': 0,
          'skin_dir': '',
          'status': 0,
          'prize_json': []
        }
      ],
      skinId: [62, 19, 67, 68],
      chessId: [],
      shield: [],
      sieve: [],
      areaId: []
    }
  },
  created() {
    this.getRewardTypeData()
    this.getSkuList()
    this.getTables()
  },
  methods: {
    handleClose(done, index) {
      this.drawerArr[index].visible = false
    },
    priceChange(v, index) {
      let sku = ''
      for (const i in this.shopSku) {
        const val = this.shopSku[i]
        if (val.value === v) {
          sku = val.sku
          break
        }
      }

      if (!sku) {
        this.msgError('sku有误')
        return
      }

      this.formData[index].sku = sku
    },
    getSkuList() {
      getSku({ type: 3 }).then(res => {
        if (res.code === 200) {
          this.shopSku = []
          res.data.forEach((item) => {
            this.shopSku.push({ label: item.price, value: item.price, sku: item.sku })
          })
        } else {
          this.msgError(res.msg)
        }
      })
    },
    getRewardTypeData() {
      getRewardType().then(res => {
        if (res.code === 200) {
          for (const i in res.data) {
            this.rewardType.push({ 'label': res.data[i], 'value': parseInt(i) })
          }
        }
      })
    },
    addReward(index) {
      this.formData[index].prize_json.push({
        propsId: 1,
        skin: 0,
        num: 0,
        rtype: 2
      })
    },
    removeReward(index, i) {
      this.formData[index].prize_json = this.formData[index].prize_json.filter((item, key) => {
        return i !== key
      })
    },
    onSubmit() {
      for (const i in this.formData) {
        const val = this.formData[i]
        if (val.min_level > val.max_level) {
          this.msgError('最小等级不能大于最高等级')
          return
        }
      }
      const data = JSON.stringify(this.formData)
      console.log(data)
      updateShopCfg({ data: data }).then(res => {
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.getTables()
        } else {
          this.msgError(res.msg)
        }
      })
    },
    getTables() {
      getShopCfgList(this.queryParams).then(res => {
        if (res.code === 200) {
          res.data.list.forEach((item) => {
            this.drawerArr.push({ visible: false })
          })
          this.formData = res.data.list
          this.total = res.data.count
        } else {
          this.msgError(res.msg)
        }
      })
    },
    add() {
      this.formData.push({
        'id': 0,
        'gid': 601,
        'g_type': 109,
        'min_level': 0,
        'max_level': 0,
        'life_time': 0,
        'price': this.shopSku[0].value,
        'sku': this.shopSku[0].sku,
        other_json: [],
        'discount': 0,
        'skin_dir': '',
        'status': 0,
        'prize_json': []
      })
      this.drawerArr.push({ visible: false })
    },
    del(id) {
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteShopCfg({ id: id }).then(res => {
          if (res.code === 200) {
            this.msgSuccess(res.msg)
            this.getTables()
          } else {
            this.msgError(res.msg)
          }
        })
      })
    }, getRewardList(prize) {
      return getRewardListForPropsId(prize, this.rewardType)
    }
  }
}
</script>

<style scoped>
</style>
